
import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../components/input';

const FormUsuario = ({ data, disabled }) => (
  <form>
    <div className="form-info-container">
      <div className="form-info-container__box-container">
        <div className="form-info-container__box">
          <Input
            placeholder=""
            name="Email"
            label="Email"
            value={data.email}
            inputType="text"
            disabled={disabled}
          />
          <Input
            placeholder=""
            name="nombre"
            label="Nombre"
            value={data.nombre}
            inputType="text"
            disabled={disabled}
          />
          <Input
            placeholder=""
            name="empresa"
            label="Empresa"
            value={data.empresa}
            inputType="text"
            disabled={disabled}
          />
        </div>
        <div className="form-info-container__box">
          <Input
            placeholder=""
            name="celular"
            label="Celular"
            value={String(data.celular)}
            inputType="text"
            disabled={disabled}
          />
          <Input
            placeholder=""
            name="puesto"
            label="Puesto"
            value={data.puesto}
            inputType="text"
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  </form>
);
FormUsuario.propTypes = {
  data: PropTypes.shape({
    nombre: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
};
export default FormUsuario;
